import styled, { css } from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;

  @media ${(props) => props.theme.device.tabletL} {
    margin-top: 30px;
    position: relative;
    min-height: 300px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

const ChartContainer = styled.div`
  position: relative;
  width: 50%;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;

const Chart = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media ${(props) => props.theme.device.mobileL} {
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }
`;

const percentageSize = 54;
const radius = 110;
export const Percentage = styled.div`
  opacity: 0;
  @keyframes show-up {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation: 400ms ease 1s show-up forwards;
  width: ${percentageSize}px;
  height: ${percentageSize}px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  box-shadow: 0px 3.45798px 6.91595px rgba(0, 0, 0, 0.1);
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(
      ${-percentageSize / 2}px,
      calc(135px - ${percentageSize / 2}px)
    )
    rotate(${(props) => props.rotate}deg);
  transform-origin: ${percentageSize / 2}px calc(-${radius}px);

  > div {
    transform: rotate(-${(props) => props.rotate}deg);
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: 135px;
  }
`;

const ProgressCourseContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 1ppx;
    line-height: 29px;

    &.number {
      font-weight: 600;
      font-size: 50px;
      line-height: 38px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: 135px;
    left: 50%;
  }
`;

const CourseNumber = styled.span`
  color: ${(props) => props.theme.colors.textPrimary};
`;

const CourseIcon = styled.span`
  font-size: 32px;
  color: ${(props) => props.theme.colors.textPrimary};
`;

const CourseActive = styled.span`
  text-align: center;
  color: ${(props) => props.theme.colors.textPrimary};

  &:first-letter {
    text-transform: capitalize;
  }
`;

const ProgressBarContainer = styled.div`
  width: 50%;

  .progress-content {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
  }

  & > div:last-child {
    border: none;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    margin-top: 300px;
  }
`;

const NumberItem = styled.span`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${(props) => props.theme.colors.textPrimary};
`;

const StateLabel = styled.div`
  margin: 0 auto;
  padding: 24px 0;
  color: ${(props) => props.theme.colors.textPrimary};
  max-width: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 11px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
`;

export const Legend = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 2px;
  ${({ color }) => css`
    background-color: ${color};
  `}
`;

export {
  Container,
  ChartContainer,
  ProgressCourseContainer,
  Chart,
  CourseNumber,
  CourseIcon,
  CourseActive,
  ProgressBarContainer,
  NumberItem,
  StateLabel,
};
